// @flow
import _ from 'lodash';

import type { TRootStore } from '../../types/';

const getTeamsById = (state: TRootStore) =>
	_.get(state, 'leagues.teams_by_id', {});

export default getTeamsById;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getTeamsById.js